<li class="email-wrapper">
  <a class='email' data-email="{{value}}">
    <span>Email:</span>{{value}}
  </a>
</li>
